export const routesAdmin = [
  {
    path: "/laravel_log",
    name: "laravel_log",
    component: () => import("@/views/admin/LogViewer.vue"),
    meta: {
      public: false,
      title: "admin.laravel log",
      yetki: { p: true },
    },
  },
  {
    path: "/eklentiler",
    name: "eklentiler",
    component: () => import("@/views/admin/Eklentiler.vue"),
    meta: {
      public: false,
      title: "admin.Eklentiler",
      yetki: { p: true },
    },
  },
  {
    path: "/activity_log",
    name: "activity_log",
    component: () => import("@/views/admin/ActivityLog.vue"),
    meta: {
      public: false,
      title: "admin.ActivityLog",
      yetki: { p: true },
    },
  },

  // {
  //   path: "/ScheduleMonitor",
  //   name: "ScheduleMonitor",
  //   component: () => import("@/views/admin/LogViewer.vue"),
  //   meta: {
  //     public: false,
  //     title: "Schedule Monitor",
  //     yetki: { p: true },
  //   },
  // },
  // {
  //   path: "/ceviri",
  //   name: "ceviri",
  //   component: () => import("@/views/admin/ceviri.vue"),
  //   meta: {
  //     public: false,
  //     title: "Çeviri",
  //     yetki: { a: true },
  //   },
  // },
]
